<template>
  <form
      id="search-form"
      @submit.prevent
      class="meilisearch-search-wrapper h-full search-box relative"
      role="search"
  >
    <input
        ref="searchInputRef"
        id="iungo-search-input"
        v-model="searchInput"
        :placeholder="placeholder"
        class="search-query border border-gray-300 rounded-md px-2 py-1 focus:border-gray-500 focus:outline-none text-sm focus:shadow-sm appearance-none"
        @blur="hideMenu"
        @focus="showMenu"
        @click="showMenu"
    />

    <transition name="fade">
      <div v-if="loading" class="absolute top-0 right-0 mt-1 mr-1.5 text-gray-400">
        <i class="fal fa-circle-notch fa-spin"></i>
      </div>
    </transition>
  </form>
</template>

<script setup>
import { ref, watch, onMounted, getCurrentInstance, nextTick } from 'vue'
import DocsSearchBar from './src/lib/DocsSearchBar'

// define incoming props
const props = defineProps({
  eventId:  { type: String, default: null },
  domain:   { type: String, default: null },
  // if you want to allow dynamic re-configuration:
  options:  { type: Object, default: () => ({}) },
})

// emit events
const emit = defineEmits(['open-event-item'])

// local refs
const loading          = ref(false)
const placeholder      = ref('Search')
const docsSearchBar    = ref(null)
const searchInput      = ref('')
const searchInputRef   = ref(null)

// access global translate or site config (if using VuePress/other)
const { proxy } = getCurrentInstance()
function t(key) {
  return proxy.translate?.(key)
      || proxy.$site?.themeConfig?.searchPlaceholder
      || ''
}

// build & (re)initialize the search instance
function initialize(userOptions) {
  loading.value = true
  const cfg = {
    hostUrl: `https://${props.domain}/customer/searchEvent/${props.eventId}`,
    autocompleteOptions: { debug: true },
    inputSelector: searchInputRef.value,
    queryHook: (query) => {
      loading.value = true
      return query
    },
    transformData: (hits) => {
      
      loading.value = false
      console.log("hits_2", hits)
      return hits
    },
    handleSelected: (inputEl, event, suggestion) => {
      if (suggestion.entity?.type === 'App\\Models\\Event\\EventItem') {
        emit('open-event-item', suggestion.entity.id)
      }
      // add other entity handlers here...
    },
    ...userOptions,
  }
  docsSearchBar.value = new DocsSearchBar(cfg)
  loading.value = false
}

// hide the dropdown
function hideMenu() {
  docsSearchBar.value?.autocomplete?.autocomplete.close()
}

// show it (if there’s anything typed)
function showMenu() {
  if (searchInput.value?.length > 0) {
    docsSearchBar.value?.autocomplete?.autocomplete.open()
  }
}

// watch for external options changes
watch(
    () => props.options,
    (newOpts) => {
      initialize(newOpts)
      nextTick(() => docsSearchBar.value?.autocomplete?.autocomplete.open())
    },
    { deep: true }
)

// on mount: set placeholder, init search
onMounted(() => {
  placeholder.value = t('conference.search')
  initialize(props.options)
})
</script>

<style scoped>
.docs-searchbar-suggestion--highlight {
  background-color: #dcfce7;
}

.autocomplete-mh {
  max-height: calc(100vh - 4rem);
  min-width: 32rem;
}

@media (max-width: 47rem) {
  .autocomplete-mh {
    max-height: calc(100vh - 6rem);
    min-width: 23rem;
  }
}

@media (max-width: 64rem) {
  .autocomplete-mh {
    min-width: 23rem;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
